<div class="manage-wellspace-header">
  <h1>{{ showNativeTeamSettings ? 'Team Settings' : 'Manage Your Wellspace' }}</h1>
  <a *ngIf="showNativeTeamSettings" mat-stroked-button routerLink="/my-team" queryParamsHandling="preserve">
    <mat-icon>arrow_back</mat-icon> Back to My Team
  </a>
  <button
    *ngIf="canOpenNewTeamsExperience"
    mat-raised-button
    color="primary"
    type="button"
    (click)="openNewTeamsExperience()"
  >
    <mat-icon>open_in_new</mat-icon>
    Open in new Teams experience
  </button>
</div>
  <nav mat-tab-nav-bar [tabPanel]="tabs">
    <a mat-tab-link *ngFor="let link of links"
       (click)="onLinkClick(link)"
       [disabled]="link.title === 'Plan' && !isApproved"
       [active]="activeLink == link">{{ link.title }}</a>
  </nav>
  <app-teamedit *ngIf="activeLink?.title === 'Overview'"></app-teamedit>
  <app-team-set-benefits *ngIf="activeLink?.title === 'Benefits'"
    (emitHasUnsavedChanges)="setHasUnsavedChanges($event)"
    (emitChangesWereSaved)="setHasUnsavedChanges($event)">
  </app-team-set-benefits>
  <app-team-add-members *ngIf="activeLink?.title === 'Members'"></app-team-add-members>
  <app-managewellspace-products *ngIf="activeLink?.title === 'Products'" [teamId]="activeProductsTeamId" [companyId]="companyId"></app-managewellspace-products>
  <app-program *ngIf="activeLink?.title === 'Rewards history'"></app-program>
  <app-plan *ngIf="activeLink?.title === 'Plan'"></app-plan>
  <mat-tab-nav-panel #tabs></mat-tab-nav-panel>
